import { parseTenantSlugFromHost } from "@gigflow/shared";

const ROOT_DOMAIN =
  import.meta.env.VITE_PLATFORM_ROOT_DOMAIN?.trim().toLowerCase() || "";

export function getPlatformRootDomain(): string {
  return ROOT_DOMAIN;
}

export function getTenantSlugFromHost(): string | null {
  if (typeof window === "undefined" || !ROOT_DOMAIN) return null;
  return parseTenantSlugFromHost(window.location.hostname, ROOT_DOMAIN);
}

export function useSiteSlug(paramSlug = ""): string {
  return paramSlug || getTenantSlugFromHost() || "";
}

export type SiteSegment = "login" | "register" | "book" | "portal";

export function sitePath(
  slug: string,
  segment?: SiteSegment,
  query?: { preview?: boolean },
): string {
  const onTenantHost = getTenantSlugFromHost() !== null;
  let path: string;
  if (onTenantHost) {
    path = segment ? `/${segment}` : "/";
  } else if (segment) {
    path = `/site/${slug}/${segment}`;
  } else {
    path = `/site/${slug}`;
  }
  if (query?.preview) {
    path += path.includes("?") ? "&preview=1" : "?preview=1";
  }
  return path;
}

export function siteResolveQuery(slug: string, preview: boolean): string {
  const hostSlug = getTenantSlugFromHost();
  const qs = new URLSearchParams();
  if (hostSlug) {
    qs.set("host", window.location.hostname.split(":")[0] ?? hostSlug);
  } else if (slug) {
    qs.set("slug", slug);
  }
  if (preview) qs.set("preview", "1");
  return qs.toString();
}
